/**
 * @voltxampere/ui — LM4040-2.5 voltage reference variant (Sprint 42-3)
 *
 * Reference: TI LM4040-2.5. Fixed 2.500 V shunt voltage reference,
 * ±0.1 %, SOT-23. Engine zero-diff via canonical "voltage-source".
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const referenceLm4040_2v5 = {
    id: "lm4040-2v5",
    nameTr: "LM4040-2.5 (Hassas Referans 2.5V, SOT-23)",
    nameEn: "LM4040-2.5 (Precision Reference 2.5V, SOT-23)",
    shortcut: "V",
    category: "source",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "LM4040-2.5",
    schemaType: "voltage-source",
    defaultParams: { voltage: 2.5 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=reference-lm4040-2v5.js.map